import template from './grid.html';
import {GridController} from './grid.controller.js';

const GridComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: GridController,
    controllerAs: 'vm',
    bindings: {
        items: '<',
        onDblClick: '&',
        onDelete: '&',
        showDelete: '<'
    }
};

export {GridComponent};



// WEBPACK FOOTER //
// ./app/components/pacijent/grid/grid.js